module.exports = __webpack_public_path__ + "img/icon-metro.bddd144f.png";